import { render, staticRenderFns } from "./attachmentList.vue?vue&type=template&id=94ac1b00&scoped=true&"
import script from "./attachmentList.vue?vue&type=script&lang=js&"
export * from "./attachmentList.vue?vue&type=script&lang=js&"
import style0 from "./attachmentList.vue?vue&type=style&index=0&id=94ac1b00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ac1b00",
  null
  
)

export default component.exports